import http from "./http";
import Service from "../Service";

export default class SellerGroupService extends Service {

	all(data) {
		return http.get("sellers/groups", {
			headers: this.getHeaders(),
			params: data
		});
	}

	load(id, data) {
		return http.get(`sellers/groups/${id}`, {
			headers: this.getHeaders(),
			params: data
		});
	}

	save(group) {
		return http.post(`sellers/groups/`, group, {
			headers: this.getHeaders()
		});
	}

	update(group) {
		return http.put(`sellers/groups/${group.id}`, group, {
			headers: this.getHeaders()
		});
	}

	remove(id, data) {
		return http.delete(`sellers/groups/${id}`, {
			headers: this.getHeaders(),
			params: data
		});
	}

	add_to_group(id, data) {
		return http.post(`sellers/groups/add/${id}`, data, {
			headers: this.getHeaders()
		});
	}

	remove_from_group(id, data) {
		return http.delete(`sellers/groups/remove/${id}`, {
			headers: this.getHeaders(),
			params: data
		});
	}

}
